import { SignInResponseDTO } from './dtos/SignInResponseDTO';
import { SignInRequestDTO } from './dtos/SignInRequestDTO';

import { setupApi } from '.';

export async function signIn(
  data: SignInRequestDTO,
  ctx = undefined
): Promise<SignInResponseDTO> {
  const response = await setupApi(ctx).post<SignInResponseDTO>('/auth', data);

  return response.data;
}
